/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { colors, borderRadius, shadows, typography, transitions } from '../../styles/theme';
import { ClockIcon, ZapIcon, HeartIcon, MapPinIcon } from '../common';

const statsStyles = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  max-width: 880px;
  margin: -3rem auto 0;
  position: relative;
  z-index: 2;
  padding: 0 1rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 768px) {
    margin-top: -4rem;
    padding: 0 2rem;
  }
`;

const statCardStyles = css`
  background: white;
  padding: 1.5rem 1rem;
  border-radius: ${borderRadius.xl};
  text-align: center;
  box-shadow: ${shadows.lg};
  transition: all ${transitions.normal};

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${shadows.xl};
  }

  .icon {
    width: 44px;
    height: 44px;
    border-radius: ${borderRadius.full};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0.75rem;

    svg {
      width: 22px;
      height: 22px;
    }
  }

  .value {
    font-family: ${typography.fontFamily.heading};
    font-size: ${typography.fontSize['2xl']};
    font-weight: ${typography.fontWeight.bold};
    color: ${colors.primary[700]};
    margin-bottom: 0.25rem;
  }

  .label {
    font-size: ${typography.fontSize.sm};
    color: ${colors.text.secondary};
  }
`;

const statsData = [
  {
    value: '7/24',
    label: 'Kesintisiz Hizmet',
    color: colors.primary[100],
    iconColor: colors.primary[600],
    icon: <ClockIcon />,
  },
  {
    value: '15dk',
    label: 'Ortalama Yanıt',
    color: colors.secondary[100],
    iconColor: colors.secondary[600],
    icon: <ZapIcon />,
  },
  {
    value: '10K+',
    label: 'Mutlu Müşteri',
    color: '#dcfce7',
    iconColor: '#16a34a',
    icon: <HeartIcon />,
  },
  {
    value: '81 İl',
    label: 'Türkiye Geneli',
    color: '#fef3c7',
    iconColor: '#d97706',
    icon: <MapPinIcon />,
  },
];

export default function StatsSection() {
  return (
    <div css={statsStyles}>
      {statsData.map((stat, index) => (
        <div key={index} css={statCardStyles}>
          <div className="icon" style={{ background: stat.color, color: stat.iconColor }}>
            {stat.icon}
          </div>
          <div className="value">{stat.value}</div>
          <div className="label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}
